import React, { useState } from "react";
import { api, extractError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Notebook, Star } from "lucide-react";

const FIELDS = [
  ["activities_completed", "Activities completed"],
  ["behaviors_observed", "Behaviors observed"],
  ["successes", "Successes"],
  ["challenges", "Challenges"],
  ["meals", "Meals"],
  ["bathroom_updates", "Bathroom updates"],
  ["noteworthy_events", "Noteworthy events"],
];

export default function SessionNotesForm({ bookingId, childOptions = [], onSaved }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    activities_completed: "", behaviors_observed: "", successes: "",
    challenges: "", meals: "", bathroom_updates: "", noteworthy_events: "",
    child_id: childOptions[0] || "", mood_rating: 4,
  });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      await api.post(`/bookings/${bookingId}/session-notes`, form);
      toast.success("Session notes saved");
      setOpen(false); onSaved?.();
    } catch (err) { toast.error(extractError(err)); }
    finally { setSaving(false); }
  };

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} data-testid={`session-notes-open-${bookingId}`}
        className="btn-outline-sage text-xs">
        <Notebook className="w-3.5 h-3.5" /> Session notes
      </button>
    );
  }
  return (
    <form onSubmit={submit} className="mt-3 rounded-lg border border-stone2-200 bg-stone2-50 p-4 space-y-3"
      data-testid={`session-notes-form-${bookingId}`}>
      <div className="flex items-center justify-between">
        <span className="font-heading font-semibold text-sage-900 text-sm">Session notes</span>
        <div className="flex gap-0.5">
          {[1,2,3,4,5].map((n) => (
            <button key={n} type="button" onClick={() => setForm((f) => ({ ...f, mood_rating: n }))}
              data-testid={`session-notes-mood-${bookingId}-${n}`}>
              <Star className={`w-4 h-4 ${n <= form.mood_rating ? "text-ochre-500 fill-ochre-500" : "text-stone2-300"}`} />
            </button>
          ))}
        </div>
      </div>
      {FIELDS.map(([k, label]) => (
        <div key={k}>
          <label className="field-label">{label}</label>
          <textarea rows={2} value={form[k]}
            onChange={(e) => setForm((f) => ({ ...f, [k]: e.target.value }))}
            data-testid={`session-notes-${k}-${bookingId}`}
            className="w-full rounded-lg border border-stone2-200 bg-white px-3 py-2 text-sm" />
        </div>
      ))}
      <div className="flex justify-end gap-2">
        <button type="button" onClick={() => setOpen(false)} className="btn-secondary text-xs">Cancel</button>
        <button type="submit" disabled={saving} data-testid={`session-notes-submit-${bookingId}`} className="btn-primary text-xs">
          {saving ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Notebook className="w-3.5 h-3.5" />} Save notes
        </button>
      </div>
    </form>
  );
}
